import { call, put } from 'redux-saga/effects'
import actionTypes from '../../../actions/actionTypes'
import { OVERLAY_TEXT } from '../../../constants/overlayTypes'


export function* overlaySetOverlayType(overlayType) {
    yield put({type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE, payload: {overlayType: overlayType}})
}

export function* overlaySetRequestType(requestType) {
    yield put({type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE, payload: { requestType: requestType }})
}

export function* getProgramData(response) {
    if(!response.data) {
        throw new Error('No data from api')
    } else {
        return yield response.data
    }
}

export function* onSuccess(successType, programData, displayOverlay = false) {
    yield put({type: successType, programData: programData})

    if(displayOverlay) {
        yield call(overlaySetOverlayType, OVERLAY_TEXT)
    }
}

export function* onError(errorType, errorMessage) {
    yield put({type: errorType, errorMessage: errorMessage})
    yield call(overlaySetOverlayType, OVERLAY_TEXT)
}